import { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance';

import { ConfigState, GetterClass } from '../../../models';

export class InstancesGetter implements GetterClass {

  public static execute(state: ConfigState): Instance[] {
    return state.instances;
  }

}
